var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table"},[_vm._m(0),_vm._l((_vm.lines),function(line){return [_c('tr',{key:line.ID},[_c('td',[_vm._v(_vm._s(line.Code))]),_c('td',[_vm._v(_vm._s(_vm.formatPrice(line.Total.toString())))])])]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('th',[_vm._v("Invoice Code")]),_c('th',[_vm._v("Amount")])])
}]

export { render, staticRenderFns }